import React from 'react';
import { Search } from 'react-feather';
import { useFeatureFlags } from 'components/shared/hooks';
import FeatureFlag from 'components/shared/FeatureFlag';

const FilterSearch = ({
  improvedSearch,
  handleChange,
  searchQuery,
  allowEmpty,
  overridePlaceholder,
}) => {
  let placeholder =
    useFeatureFlags(['advanced_content_search']) && improvedSearch
      ? t('common.search_title_by_keyword_or_phrase')
      : t('common.search');

  if (overridePlaceholder) {
    placeholder = overridePlaceholder;
  }

  return (
    <input
      className="NewInput NewInput--lightestGray"
      type="search"
      placeholder={placeholder}
      onChange={handleChange}
      value={searchQuery}
      required={allowEmpty}
    />
  );
};

class IndexSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: props.value || '',
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      searchQuery: nextProps.value,
    });
  }

  handleChange(e) {
    this.setState({
      searchQuery: e.target.value,
    });
  }

  handleSubmit(e) {
    const { searchQuery } = this.state;
    e.preventDefault();
    if (this.props.allowEmpty || searchQuery.trim().length > 0) {
      this.props.submitCallback(this.state.searchQuery);
    }
  }

  render() {
    return (
      <form
        className={`IndexFilter IndexFilter-search ${this.props.className}`}
        onSubmit={this.handleSubmit}
        ref="form"
      >
        {this.props.improvedSearch && (
          <FeatureFlag features={['advanced_content_search']}>
            <Search size={18} className="pos-a c-midnight-50 ml-8 mt-8" />
          </FeatureFlag>
        )}
        <FilterSearch
          improvedSearch={this.props.improvedSearch}
          handleChange={this.handleChange}
          searchQuery={this.state.searchQuery}
          allowEmpty={!this.props.allowEmpty}
          overridePlaceholder={this.props.overridePlaceholder}
        />
      </form>
    );
  }
}

export default IndexSearch;
